import { styled, Typography } from '@mui/material';
import { Button } from 'components/Button/Button';
import { IconButton } from 'components/IconButton';
import { EntryFields } from '../shared/EntryFields';
import { EntryEditorProps } from '../types';
import { sidebarTopGap, useSidebarViewport } from './useSidebarViewport';

const Sidebar = styled('aside')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: 376,
    minWidth: 0,
    paddingLeft: theme.spacing(2),
}));

const SidebarEditor = styled('div')(({ theme }) => ({
    position: 'sticky',
    top: sidebarTopGap,
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    minHeight: 0,
    borderRadius: 16,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
}));

const SidebarHeader = styled('div')(({ theme }) => ({
    flexShrink: 0,
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(1, 2),
}));

const SidebarActions = styled('div')(({ theme }) => ({
    flexShrink: 0,
    marginTop: 'auto',
    padding: theme.spacing(2),
}));

export function EntrySidebar(props: EntryEditorProps) {
    const { sidebarRef, maxHeight } = useSidebarViewport();

    return (
        <Sidebar ref={sidebarRef}>
            <SidebarEditor style={{ maxHeight }}>
                <SidebarHeader>
                    <Typography variant='subtitle1' fontWeight={600}>
                        {props.readOnly
                            ? 'Visa rad'
                            : props.isNew
                              ? 'Lägg till rad'
                              : 'Redigera rad'}
                    </Typography>
                    <IconButton
                        icon='right_panel_close'
                        size='sm'
                        variant='text'
                        tooltip='Stäng panel'
                        onClick={props.onClose}
                    />
                </SidebarHeader>
                <EntryFields
                    {...props}
                    autoFocus={props.isNew && !props.draft.startTime}
                />
                {!props.readOnly && (
                    <SidebarActions>
                        <Button
                            variant='outlined'
                            icon='delete'
                            sx={{ color: 'error.main' }}
                            fullWidth
                            disabled={props.disabled}
                            onClick={props.onDelete}>
                            Ta bort rad
                        </Button>
                    </SidebarActions>
                )}
            </SidebarEditor>
        </Sidebar>
    );
}
